import React from 'react'
import BulkActions from "./BulkActions";

function CustomerManagerTableHead(props) {
    const {onCheckALl, selectAll, arrSelected} = props

    const _handleChangeChecked = (e) => {
        const {checked} = e.target

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    return <thead className="TableHead">
    <tr>
        <th className="bulkActions">
            <BulkActions selectAll={selectAll} arrSelected={arrSelected} onChange={_handleChangeChecked}/>
        </th>
        <th className="leadName">Tên KH</th>
        <th className="custName">SĐT</th>
        <th className="status">Trạng thái gọi</th>
    </tr>
    </thead>
}

export default CustomerManagerTableHead
